import React from "react";
import PolicyPagesLayout from "../Layout/PolicyPagesLayout";
import PrivacyPolicy from "../Components/Pages/PrivacyPolicy";

const PrivacyPolicyPage = () => {
  return (
    <>
      <PolicyPagesLayout>
        <PrivacyPolicy />
      </PolicyPagesLayout>
    </>
  );
};

export default PrivacyPolicyPage;
